import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { Button, Spinner } from "@/components/ui-kit";
import { APP } from "@/config";
import { CheckCircle2, AlertCircle } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token");
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!token) { setState("error"); return; }
    api.post("/leads/unsubscribe", { token })
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="band-3-5 min-h-screen bg-[var(--ns-bg)] grid place-items-center px-5">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-[var(--ns-surface)] rounded-[var(--ns-radius)] border border-[var(--ns-border)] p-8 text-center ns-card" data-testid="unsubscribe-page">
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-xl bg-[var(--ns-primary)] text-white grid place-items-center font-head font-bold">N</div>
          <span className="font-head text-lg font-bold">{APP.name}</span>
        </div>
        {state === "loading" && <Spinner label="Updating your preferences" />}
        {state === "ok" && (
          <>
            <CheckCircle2 size={48} className="mx-auto text-[#2A8555]" />
            <h1 className="font-head text-2xl font-bold mt-3">You're unsubscribed</h1>
            <p className="text-[var(--ns-muted)] mt-2">You won't receive any more emails from the resource series. Changed your mind? You can sign up again anytime.</p>
            <Button variant="outline" className="mt-6 mx-auto" onClick={() => nav("/")}>Back to home</Button>
          </>
        )}
        {state === "error" && (
          <>
            <AlertCircle size={48} className="mx-auto text-[#B23A28]" />
            <h1 className="font-head text-2xl font-bold mt-3">Link not valid</h1>
            <p className="text-[var(--ns-muted)] mt-2">This unsubscribe link is invalid. If you keep getting emails, reply to one and we'll remove you.</p>
            <Button variant="outline" className="mt-6 mx-auto" onClick={() => nav("/")}>Back to home</Button>
          </>
        )}
      </motion.div>
    </div>
  );
}
